import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { api } from "@/lib/api";
import PriceChart from "@/components/PriceChart";

const fmtRate = (v) => Number(v).toFixed(4);

export default function FxPanel() {
  const [pairs, setPairs] = useState([]);
  const [sel, setSel] = useState("EUR/USD");
  useEffect(() => { api.get("/fx").then((r) => setPairs(r.data)); }, []);
  const cur = pairs.find((p) => p.pair === sel);

  return (
    <section className="mt-12" data-testid="fx-panel">
      <h2 className="text-lg font-bold text-[var(--navy)] mb-4 flex items-center gap-2"><Globe size={18} className="text-[var(--blue)]" /> Foreign exchange rates</h2>
      <div className="tile">
        <div className="p-5 flex flex-wrap gap-2 border-b" data-testid="fx-pair-list">
          {pairs.map((p) => (
            <button key={p.pair} onClick={() => setSel(p.pair)} className={`text-left px-4 py-2 rounded-lg border transition-colors ${p.pair === sel ? "border-[var(--blue)] bg-blue-50" : "hover:border-slate-300"}`} data-testid={`fx-pair-${p.pair.replace("/", "")}`}>
              <div className="text-xs font-semibold text-slate-500">{p.pair}</div>
              <div className="font-display font-semibold text-[var(--navy)]">{fmtRate(p.rate)}</div>
              <div className={`text-[11px] font-semibold ${p.change_pct >= 0 ? "text-emerald-700" : "text-[var(--red)]"}`}>{p.change_pct >= 0 ? "+" : ""}{p.change_pct}% 24h</div>
            </button>
          ))}
        </div>
        {cur && (
          <div className="px-5 pt-4">
            <div className="text-sm text-slate-500">{sel}</div>
            <div className="text-3xl font-display font-bold text-[var(--navy)]" data-testid="fx-current-rate">{fmtRate(cur.rate)}</div>
          </div>
        )}
        <PriceChart symbol={sel} endpoint="/fx/history" params={{ pair: sel }} fmt={fmtRate} testid={`fx-${sel}`} />
        <p className="px-5 pb-4 text-[11px] text-slate-400">Simulated indicative rates, updated hourly.</p>
      </div>
    </section>
  );
}
